import React, { FC } from 'react';
import styles from './AvailabilityToggle.module.css';
import { Typography, TypographyTagVariants } from '@components/atoms/Typography';
import { useTranslation } from 'react-i18next';

export interface AvailabilityToggleProps {
    available: boolean; // controlled prop
    onToggle: (available: boolean) => void;
}

export const AvailabilityToggle: FC<AvailabilityToggleProps> = ({ available, onToggle }) => {
    const { t } = useTranslation();

    const translations = {
        available: t('availability-toggle.available'),
        unavailable: t('availability-toggle.unavailable'),
    };

    const handleToggle = () => {
        onToggle(!available);
    };

    return (
        <div
            className={`${styles.toggleContainer} ${available ? styles.available : styles.unavailable}`}
            onClick={handleToggle}
            role="button"
            aria-pressed={available}
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === ' ' || e.key === 'Enter') {
                    e.preventDefault();
                    handleToggle();
                }
            }}>
            <div className={styles.toggleCircle}>
                <i className={available ? 'fa-thin fa-car-on' : 'fa-thin fa-car'} />
            </div>
            <Typography fontSize="12" fontWeight="800" color="dark" classes="toggleLabel" tagVariant={TypographyTagVariants.span}>
                {available ? translations.available : translations.unavailable}
            </Typography>
        </div>
    );
};
